module.exports = __webpack_public_path__ + "assets/manual_snughome-a736df2f6b9fe602006b58621527d122.pdf";